// angular imports
import { 
    WritableSignal, 
    signal 
} from "@angular/core";

//local imports
import { IBreadcrumbItemModel, ListItemFactory } from "@app/shared";
import { RoomContentDto } from "@app/catalog";
import { AbstractRoomContentModel } from "@app/catalog-common";


export class RoomContentModel extends AbstractRoomContentModel implements IBreadcrumbItemModel
{
    public category: WritableSignal<string>;
    public thumbnailUrl: WritableSignal<string>;
    public quantity: WritableSignal<number>;
    public canEdit: WritableSignal<boolean>;
    public shouldAddBreadcrumb: WritableSignal<boolean> = signal<boolean>(true);

    constructor()
    {                
        super();
        this.category = signal<string>(null);
        this.thumbnailUrl = signal<string>(null);    
        this.quantity = signal<number>(null);    
        this.canEdit = signal<boolean>(false);
    }

    public setShouldAddBreadcrumb(value: boolean): void {
        this.shouldAddBreadcrumb.set(value);
    }

    public static fromDto(dto: RoomContentDto)
    {
        let roomContent = new RoomContentModel();

        roomContent.id = dto.id;
        roomContent.name.set(dto.name);
        roomContent.code.set(dto.code);
        roomContent.thumbnailUrl.set(dto.thumbnailUrl);
        roomContent.quantity.set(dto.quantity);
        roomContent.isActive.set(dto.isActive);
        roomContent.canEdit.set(dto.canEdit);

        return roomContent;
    }

    public toListItem = (selected: boolean = false) => 
        ListItemFactory.create<RoomContentModel>(this.name, this.id, this, selected);
    

    public toListItem$ = (selected: WritableSignal<boolean>) =>
        ListItemFactory.create$<RoomContentModel>(this.name, this.id, this, selected);    

}
